import { defineComponent as _defineComponent } from 'vue'
import { inject, onBeforeUnmount, onMounted, ref, watch } from 'vue'

import { mapSymbol } from './utils'

export type MapMarkerLegacyEvents = {
  (e: 'click', event: google.maps.MapMouseEvent): void
  (e: 'drag', event: google.maps.MapMouseEvent): void
  (e: 'dragend', event: google.maps.MapMouseEvent): void
  (e: 'dragstart', event: google.maps.MapMouseEvent): void
}

export interface MapMarkerLegacyProps {
  options: google.maps.MarkerOptions
  hide?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MapMarkerLegacy',
  props: {
    options: null,
    hide: { type: Boolean }
  },
  emits: ["click", "drag", "dragend", "dragstart"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'click', event: google.maps.MapMouseEvent): void
  (e: 'drag', event: google.maps.MapMouseEvent): void
  (e: 'dragend', event: google.maps.MapMouseEvent): void
  (e: 'dragstart', event: google.maps.MapMouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: google.maps.MarkerOptions
  hide?: boolean
};

/**
 * @deprecated This component uses the legacy google.maps.Marker API which was deprecated
 * on February 21, 2024 (v3.56). Please use MapMarker with AdvancedMarkerElement instead
 * whenever possible. This component should only be used if it is not possible to use
 * the new AdvancedMarkerElement API.
 *
 * See: https://developers.google.com/maps/documentation/javascript/markers
 * Migration guide: https://developers.google.com/maps/documentation/javascript/advanced-markers/migration
 */



const map = inject(mapSymbol, ref())
const marker = ref<google.maps.Marker>()

onMounted(() => {
  // Create the legacy marker
  marker.value = new google.maps.Marker({
    ...props.options,
    map: props.hide ? null : map.value,
  })

  // Add event listeners
  marker.value.addListener('click', (e: google.maps.MapMouseEvent) =>
    emit('click', e),
  )
  marker.value.addListener('drag', (e: google.maps.MapMouseEvent) =>
    emit('drag', e),
  )
  marker.value.addListener('dragend', (e: google.maps.MapMouseEvent) =>
    emit('dragend', e),
  )
  marker.value.addListener('dragstart', (e: google.maps.MapMouseEvent) =>
    emit('dragstart', e),
  )
})

onBeforeUnmount(() => {
  if (marker.value) {
    marker.value.setMap(null)
  }
})

// Watch for changes in hide prop
watch(
  () => props.hide,
  (hide) => {
    if (marker.value) {
      marker.value.setMap(hide ? null : map?.value || null)
    }
  },
)

// Watch for changes in options
watch(
  () => props.options,
  (options) => {
    if (marker.value) {
      marker.value.setOptions({
        map: props.hide ? null : map.value,
        ...options,
      })
    }
  },
  { deep: true },
)

watch(map, (newMap) => {
  if (marker.value) {
    marker.value.setMap(props.hide ? null : newMap || null)
  }
})

expose({ marker })

return { __sfc: true,props, emit, map, marker }
}

})